<template>
  <div id="product-external-edit-url">
    <b-row>
      <!-- Data Product External -->
      <b-col md="12">
        <h5 class="mb-1">
          Produk Eksternal <small
            v-if="data.owner_gift.owner.dont_switch_external_registry"
            class="badge badge-danger"
          >
            <feather-icon
              icon="FlagIcon"
              class="mr-25"
            />
            Ditandai Jangan Ubah</small>
        </h5>
        <ProductItem
          :img="data.product.images.length ? data.product.images[0].image_url : ''"
          :title="data.product.name"
          :subtitle="data.product.description"
          :price="toCurrency(data.product.price)"
        />
      </b-col>

      <b-col md="12">
        <hr class="my-1">
      </b-col>

      <!-- Step 1: Pick Product Internal -->
      <b-col
        v-if="!data.is_purchase"
        md="12"
      >
        <b-row
          align-h="between"
          align-v="center"
        >
          <b-col cols="auto">
            <h5 class="mb-1">
              Pilih Produk Internal
            </h5>
          </b-col>
          <b-col
            v-if="switchStep === 2"
            cols="auto"
          >
            <b-button
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-danger"
              class="btn-icon rounded-circle"
              @click="$store.commit('products/RESET_SWITCH')"
            >
              <feather-icon icon="XCircleIcon" />
            </b-button>
          </b-col>
        </b-row>
        <!-- Search Produk Internal -->
        <div v-if="switchStep === 1">
          <SearchProduct
            :load-more="true"
            :initial-keyword="recommendedSearchKeyword"
            @on-select="onPickSiwtchProduct"
          >
            <template #content>
              <p class="text-muted mt-1 mb-0">
                Pastikan memilih produk yang paling mendekati
              </p>
            </template>
          </SearchProduct>
        </div>

        <!-- Data Produk Internal terpilih -->
        <div v-if="proudctPicked">
          <ProductItem
            :img="proudctPicked.images.length ? proudctPicked.images[0].image_url : ''"
            :title="proudctPicked.name"
            :subtitle="`by ${proudctPicked.merchant.name}`"
            :price="toCurrency(proudctPicked.price)"
          />
          <hr class="my-1">
        </div>
      </b-col>

      <!-- Step 2: Pick Variant -->
      <b-col
        v-if="switchStep === 2 && !data.is_purchase"
        md="12"
      >
        <h5 class="mb-1">
          Pilih Varian
        </h5>

        <div v-if="proudctPicked.variants">
          <v-select
            v-model="skuPicked"
            label="variant"
            :options="proudctPicked.variants"
            :placeholder="`Tersedia ${proudctPicked.variants.length} Varian`"
            :selectable="(option) => option.stock > 0"
          >
            <template #option="{ variant, price, stock }">
              <b-row align-v="center">
                <b-col>
                  <h5>{{ variant }}</h5>
                  <p class="text-muted mb-0">
                    {{ toCurrency(price ? price : 0) }}
                  </p>
                </b-col>
                <b-col class="text-right">
                  {{ stock ? '' : 'stok habis' }}
                </b-col>
              </b-row>
            </template>
          </v-select>
          <p class="text-muted mt-1">
            Pastikan memilih varian yang paling mendekati
          </p>
        </div>

        <p
          v-else
          class="text-muted"
        >
          Produk ini tidak memiliki varian
        </p>

        <hr class="my-1">

        <div class="text-right">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            :variant="data.owner_gift.owner.dont_switch_external_registry ? 'danger' : 'primary'"
            class="mr-1"
            :disabled="$store.state.products.isLoadingSubmit"
            @click="onSubmit"
          >
            <b-spinner
              v-show="$store.state.products.isLoadingSubmit"
              small
            />
            Simpan
          </b-button>
        </div>
      </b-col>

      <!-- If Product External Is Purchase -->
      <b-col v-if="data.is_purchase">
        <p
          class="text-danger"
        >
          Produk eksternal <b>{{ data.product.name }}</b> tidak dapat ditambahkan ke daftar produk internal.
          Karena sudah pernah terbeli.
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import {
  BRow,
  BCol,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ProductItem from '@/layouts/components/custom/ProductItem.vue'
import vSelect from 'vue-select'
import SearchProduct from '@/layouts/components/custom/SearchProduct.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BSpinner,
    SearchProduct,

    ProductItem,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      skuPicked: '',
    }
  },
  computed: {
    ...mapState('products', ['isLoading', 'switchExternal']),
    ...mapGetters('products', ['switchStep', 'switchPickedProduct']),
    proudctPicked() {
      return this.switchPickedProduct
    },
    externalProduct() {
      return this.data.product || {}
    },
    recommendedSearchKeyword() {
      const name = this.normalizeSuggestionKeyword(this.externalProduct.name)
      const brand = this.normalizeSuggestionKeyword(this.externalProduct.brand)
      const compactName = this.getCompactSuggestionKeyword(name)

      return [brand, compactName].filter(Boolean).join(' ') || name
    },
  },
  methods: {
    ...mapActions('products', ['switchProductExternal']),
    normalizeSuggestionKeyword(value) {
      return (value || '')
        .replace(/[^\w\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    },
    getCompactSuggestionKeyword(value) {
      const ignoredWords = ['dan', 'dengan', 'untuk', 'bayi', 'anak', 'original', 'new', 'sale']

      return value
        .split(' ')
        .filter(word => word.length > 2 && !ignoredWords.includes(word.toLowerCase()))
        .slice(0, 5)
        .join(' ')
    },
    async onSubmit() {
      let skuId = ''
      if (this.proudctPicked.variants) {
        skuId = this.skuPicked.id
      } else {
        skuId = this.proudctPicked.sku_id
      }

      if (!skuId) {
        this.$store.commit('response/SET_ERROR', {
          message: 'Anda belum memilih varian',
        })
      } else {
        await this.switchProductExternal({ idProduct: this.data.id, skuId })
        this.$emit('finish')
      }
    },
    onPickSiwtchProduct(data) {
      if (data.is_out_of_stock) return false
      return this.$store.commit('products/SET_SWITCH_PRODUCT', data)
    },
    onPickSiwtchVariant(data) {
      this.$store.commit('products/SET_SWITCH_VARIANT', data)
    },
  },
}
</script>
